'use strict';
const bubbleRect = require('@mindmup/mapjs-core/src/layout/bubble-rect'),
	css = require('../dom/css'),
	px = require('../dom/px');

module.exports = function updateNodeScreenCoordinates(domElement, node, nodeView) {
	const bubble = bubbleRect(node, nodeView);
	if (bubble) {
		css(domElement, {
			left: px(bubble.left),
			top: px(bubble.top)
		});
	} else {
		css(domElement, {
			left: px(node.x),
			top: px(node.y)
		});
	}
};

